<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">我的贷款</div>
      <choose-search @handleQuery="changeQuery"></choose-search>
      <div class="table">
        <el-table
          class="financial-services-table"
          :data="tableData"
          v-loading="Loading"
          :header-cell-style="{ textAlign: 'center',  background: '#FAFAFA',  color: '#3F434B' }"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column prop="type" label="编号">
            <template slot-scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column prop="demandName" label="项目名称">
            <template slot-scope="scope">
              <!-- type =1 代表从首页右上角点击申请贷款的，没有名称和业务类型。type =2 从我的资产点击申请贷款的，有名称和业务类型 -->
              <span v-if="scope.row.type ==1">—— ——</span>
              <span v-else>{{scope.row.demandName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="areaConfigName" label="区域"></el-table-column>
          <el-table-column label="业务类型">
            <template slot-scope="scope">
              <!-- type =1 代表从首页右上角点击申请贷款的，没有名称和业务类型。type =2 从我的资产点击申请贷款的，有名称和业务类型 -->
              <span v-if="scope.row.type ==1">农户贷</span>
              <span v-else>{{scope.row.businessTypeDesc}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="loanBank" label="贷款银行"></el-table-column>
          <!-- <el-table-column prop="maxAmount" label="贷款最高额度（万）">
            <template slot-scope="scope">{{scope.row.maxAmount != 'null' ? scope.row.maxAmount : '—— ——'}}</template>
          </el-table-column> -->
          <el-table-column prop="date" label="贷款申请提交时间">
            <template slot-scope="scope">{{scope.row.createdTime | formatTime}}</template>
          </el-table-column>
          <el-table-column prop="date" label="贷款审核状态">
            <template slot-scope="scope">
              <!-- 审核中，补资料  与 已通过 两种状态可以点击进入对应页面  -->
              <span :class="{'blueC': scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 2 || scope.row.status == 5}" @click="toDetail(scope.row)">{{scope.row.status | status}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: center;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="search.pageNumber"
          :page-size="search.pageSize"
          layout="total, prev, pager, next,jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ChooseSearch from '@/components/ChooseSearch/index.vue'
import HeaderImg from "@/components/HeaderImg";
import { sessionStore } from '@/utils/data-management';
export default {
  components: {
    ChooseSearch,
    HeaderImg,
  },
  data() {
    return {
      headerList: [
        { name: "首页", path: "/Home" },
        { name: "我的贷款", }
      ],
      Loading: false,
      tableData: [],
      search: {
        userId: this.$store.state.userInfo.id,
        pageNumber: 1,
        pageSize: 10,
        showType: 2 // 1-农户贷 2-抵押贷 3-全部
      },
      total: 0,
    }
  },
  filters: {
    status(val) {
      let status = '审核中'
      if (val == 2) {
        status =  '不通过'
      } else if (val == 3) {
        status = '审核中，补资料'
      } else if (val == 4) {
        status = '已通过'
      } else if (val == 5) {
        status = '已还清'
      }
      return status
    },
    businessType(val){
      let type = ''
      if(val=='1'){
        type = '农村土地'
      }else if(val=='2'){
        type = '林权'
      }else if(val=='3'){
        type = '涉农知识产权'
      }else if(val=='4'){
        type = '实物资产'
      }else if(val=='5'){
        type = '农业知识产权'
      }else if(val=='6'){
        type = '农业经济事项'
      }
      return type;
    },
    formatTime(val){
      let date = new Date(val);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      let D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
      return Y+M+D+h+m+s;
    },
  },
  methods: {
    //查询
    changeQuery(query) {
      if (query.chooseValue != 0) {
        this.$set(this.search, 'beginTime', query.chooseValue)
      } else {
        this.$set(this.search, 'beginTime', null)
        delete this.search.beginTime
      }
      if (query.searchValue) {
        this.$set(this.search, 'demandName', query.searchValue)
      } else {
        this.$set(this.search, 'demandName', null)
        delete this.search.demandName
      }
      this.search.pageNumber = 1
      this.getTransactionList()
    },
    getTransactionList() {
      this.loading = true
      let data = JSON.parse(JSON.stringify(this.search))
      Object.keys(data).forEach(function(key) {
        if (data[key] === '') {
          delete data[key]
        }
      })
      this.$api.apply.loanList(data) .then((res) => {
        if (res.code == 1000) {
          this.tableData =res.data
          this.total = res.total
        } else {
          this.$message.error(res.message)
        }
      }).catch((error) => {}).finally(()=>{
        this.Loading = false;
      })
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.getTransactionList()
    },
    toDetail(row) {
      if(row.type == 1){
        // 进入农户贷
        sessionStore.remove('loanApproval')
        if (row.status == 3 || row.status == 4) {
          sessionStore.set('loanApproval', row.approvalComments)
          this.$router.push({
            name: 'detailFarmerLoanPass',
            query: {
              status: row.status,
              id: row.id,
              type: row.type, // 1 农户贷  2 抵押贷款（含企业和个人）
            }
          })
        }else if(row.status == 2){
          sessionStore.set('loanApproval', row.approvalComments)
          this.$router.push({
            name: 'detailFarmerLoanNoPass',
            query: {
              status: row.status,
              id: row.id,
              type: row.type, // 1 农户贷  2 抵押贷款（含企业和个人）
              bankId: row.bankId
            }
          })
        }
      }else if(row.type == 2){
        // 进入抵押贷款
        sessionStore.remove("mortgageInfo");
        let obj = {
          approvalComments: row.approvalComments,
          status: row.status,
          id: row.id,
          type: row.type, // 1 农户贷  2 抵押贷款（含企业和个人）
          lenderType: row.lenderType, // 1.个人抵押贷   2 企业抵押贷
          demandId: row.demandId,
          demandName: row.demandName,
          businessType: row.businessType
        }
        sessionStore.set('mortgageInfo', obj)

        if (row.status == 3 || row.status == 4 || row.status == 5) {
          this.$router.push({
            name: 'detailMortgagePass',
          })
        }else if(row.status == 2){
          // 进入 未通过 详情页面，可发起重新申请
          this.$router.push({
            name:'detailMortgageNoPass', //企业抵押贷不通过的详情
            query: {
              bankId: row.bankId
            }
          })
        }
      }
    }
  },
  mounted() {
    this.getTransactionList()
  }
}
</script>
<style lang="scss" scoped>
.el-table {
  margin-bottom: 20px;
}
.blueC {
  cursor: pointer;
}
</style>